// top
header();
kv();
about();
swipe();
scrollEle();
scrollSec();
opacityChange();

// philosophy
philosophy();

// works
works();

// interview
interview_video();
interview_nav();

// faq
faq();

// sbs
sbs();
